module.exports = __webpack_public_path__ + "img/qr_code.ba13617c.jpg";